import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getBalanceAndPin } from "../../features/balance-and-pin/balanceAndPinSlice";
import { formattedBalance } from "../../features/balance-and-pin/utils";

import Spinner from "../../components/Spinner";

import { Footer, MainContainer, LogoSection, BalanceSection } from "./styles";

import copyToClipboard from "../../assets/copy-icon.svg";

import digiseqLogo from "./img/digiseq-logo.svg";

import packageJson from "../../../package.json";

const DigiseqBasicBalance = () => {
  const [searchParams] = useSearchParams();
  const serialNumber = searchParams.get("serialNumber");
  const [copied, setCopied] = useState(false);
  const [showPin, setShowPin] = useState(false);

  const dispatch = useDispatch();
  const { balanceAndPin, isLoading } = useSelector(
    (state) => state.balanceAndPin,
  );

  useEffect(() => {
    setTimeout(() => {
      setCopied(false);
    }, 2000);
  }, [copied]);

  useEffect(() => {
    if (!balanceAndPin && serialNumber) {
      dispatch(
        getBalanceAndPin({
          serial: serialNumber,
          query: "?provider=much_better",
        }),
      );
    }
  }, [balanceAndPin, serialNumber, dispatch]);

  if (isLoading) return <Spinner />;

  return (
    <MainContainer>
      <LogoSection>
        <img src={digiseqLogo} alt="digiseq-logo" />
      </LogoSection>

      <BalanceSection >
        <div onClick={() => setShowPin((state) => !state)}>
          <p>{showPin ? "Pin" : "Balance"}</p>
          {!showPin ? (
            <div className="balance-value">
              <p>{`${formattedBalance(
                balanceAndPin?.balanceDetails?.availableBalance,
                balanceAndPin?.balanceDetails?.currency,
              )}`}</p>
            </div>
          ) : (
            <div className="balance-value">
              <p>{balanceAndPin?.pinDetails?.pin || "N/A"}</p>
            </div>
          )}
        </div>
      </BalanceSection>

      <Footer>
        <div className="copyToClipboard">
          <img
            onClick={() => {
              navigator.clipboard.writeText(serialNumber);
              setCopied(true);
            }}
            src={copyToClipboard}
            alt="copy to clipboard"
          />
          <p>ID: {serialNumber}</p>
        </div>
        <div className="version">
          <p>v.{packageJson.version}</p>
        </div>
        {copied && (
          <p>
            <b>Copied to clipboard</b>
          </p>
        )}
      </Footer>
    </MainContainer>
  );
};

export default DigiseqBasicBalance;
